import api from './api'
import token from './token'

const services = {
  api,
  token,
}

export default services
